'use strict';

var _require = require('./gcpRegionCodeGroups'),
    northAmerica = _require.northAmerica,
    us = _require.us,
    asia = _require.asia,
    australia = _require.australia,
    europe = _require.europe,
    southAmerica = _require.southAmerica;

/**
 * Ordered by display preference (US regions group first, alphabetically by region group otherwise).
 *
 * Update: Clients (e.g. GUI) should manage their own ordered list, and once this is completed the comment above should
 * be removed. Though there is nothing wrong with keeping the current order in this file.
 *
 */


module.exports = {
    regions: {
        // North America
        northAmericaNorthEast1: northAmerica + '-northeast1', // Montréal
        northAmericaNorthEast2: northAmerica + '-northeast2', // Toronto
        usCentral1: us + '-central1', // Iowa
        usEast1: us + '-east1', // South Carolina
        usEast4: us + '-east4', // Northern Virginia
        usWest1: us + '-west1', // Oregon
        usWest2: us + '-west2', // Los Angeles
        usWest3: us + '-west3', // Salt Lake City
        usWest4: us + '-west4', // Las Vegas

        // Asia
        asiaEast1: asia + '-east1', // Taiwan
        asiaEast2: asia + '-east2', // Hong Kong
        asiaNorthEast1: asia + '-northeast1', // Tokyo
        asiaNorthEast2: asia + '-northeast2', // Osaka
        asiaNorthEast3: asia + '-northeast3', // Seoul
        asiaSouth1: asia + '-south1', // Mumbai
        asiaSouth2: asia + '-south2', // Delhi
        asiaSouthEast1: asia + '-southeast1', // Singapore
        asiaSouthEast2: asia + '-southeast2', // Jakarta

        // Australia
        australiaSouthEast1: australia + '-southeast1', // Sydney
        australiaSouthEast2: australia + '-southeast2', // Melbourne

        // Europe
        europeCentral2: europe + '-central2', // Warsaw
        europeNorth1: europe + '-north1', // Finland
        europeWest1: europe + '-west1', // Belgium
        europeWest2: europe + '-west2', // London
        europeWest3: europe + '-west3', // Frankfurt
        europeWest4: europe + '-west4', // Netherlands
        europeWest6: europe + '-west6', // Zürich

        // South America
        southAmericaEast1: southAmerica + '-east1', // São Paulo
        southAmericaWest1: southAmerica + '-west1' // Santiago
    },

    dualRegions: {
        asia1: 'asia1', // ASIA-NORTHEAST1 and ASIA-NORTHEAST2.
        eur4: 'eur4', // EUROPE-NORTH1 and EUROPE-WEST4.
        nam4: 'nam4' // US-CENTRAL1 and US-EAST1.
    },

    multiRegions: {
        asia: 'asia', // Data centers in Asia
        eu: 'eu', // Data centers within member states of the European Union
        us: 'us' // Data centers in the United States
    }
};